import React from 'react';
import Button from '@prisjakt/ui-button';
import { useAppContext } from '@prisjakt/ui-app-context';
import { User, AnalyticsItem, Maybe } from '../../../../types';

import * as S from './styles';

type Props = {
  me: User;
  closeMenu: () => void;
  onLogoutClick: () => void;
};

const UserView = ({ me, closeMenu, onLogoutClick }: Props) => {
  const { t } = useAppContext();
  const settingsTitle = t('account', 'menu.settings');

  return (
    <>
      <S.MenuItems>
        {me.analyticsAccess &&
          me.analyticsAccess.stores &&
          me.analyticsAccess.stores.map(
            (store: Maybe<AnalyticsItem>) =>
              store && (
                <S.MenuItem
                  key={store.name}
                  name={store.name}
                  link={store.url}
                  sidebar
                  isExternal
                  showArrow
                  data-test="MenuItemStore"
                />
              )
          )}
        {me.analyticsAccess &&
          me.analyticsAccess.brands &&
          me.analyticsAccess.brands.map(
            (brand: Maybe<AnalyticsItem>) =>
              brand && (
                <S.MenuItem
                  key={brand.name}
                  name={brand.name}
                  link={brand.url}
                  sidebar
                  isExternal
                  showArrow
                  data-test="MenuItemBrand"
                />
              )
          )}
        <S.MenuItem
          key={settingsTitle}
          name={settingsTitle}
          link="/account/settings"
          onClick={closeMenu}
          sidebar
          showArrow
        />
      </S.MenuItems>
      <S.LogoutButtonWrapper>
        <Button
          style={{ alignSelf: 'center', width: '100%' }}
          color="secondary"
          variant="outlined"
          onClick={onLogoutClick}
        >
          {t('account', 'menu.logout-button')}
        </Button>
      </S.LogoutButtonWrapper>
    </>
  );
};

export default UserView;
